import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'bottom-navbar',
    templateUrl: './bottom-navbar.component.html',
    styleUrls: ['./bottom-navbar.component.scss'],
    standalone: false
})
export class BottomNavbarComponent {
    @Input() activeUrl = '';
    constructor(private router: Router) { }

    navigateToHome () {
        this.router.navigate(['/register/dashboard']);
    }

    navigateToTasks () {
        this.router.navigate(['/register/tasks']);
    }

    navigateToMembers () {
        this.router.navigate(['/register/members']);
    }

    navigateToPlanning () {
        this.router.navigate(['/register/planning']);
    }

    navigateToReports () {
        this.router.navigate(['/register/reports']);
    }

    navigateToRefresh () {
        this.router.navigate(['/register/refresh']);
    }

    navigateToMapMembers() {
        this.router.navigate(['/register/map-members']);
    }
}
